<template>
  <div class="expert-tool-history__comparison">
    <div v-for="item in comparisonItems" :key="item.name">
      <h3 class="expert-tool-history__comparisonl-title">
        {{ item.name }}
      </h3>
      <table class="expert-tool-history__prescription-comparison">
        <tbody>
          <tr class="expert-tool-history__comparison-row expert-tool-history__prescription-comparison-previous">
            <td class="expert-tool-history__comparison-row-label" :style="'background-color: ' + item.color">
              {{ $ucfirst($t('current')) }}: {{ previousPrescriptionDate }}
            </td>
            <td class="expert-tool-history__comparison-row-chips">
              <v-chip v-for="indication in item.current" :key="indication" class="expert-tool-history__comparison-chip">
                {{ indication }}
              </v-chip>
            </td>
          </tr>
          <tr class="expert-tool-history__comparison-row expert-tool-history__prescription-comparison-selected">
            <td class="expert-tool-history__comparison-row-label">
              {{ $ucfirst($t('alerts.date')) }}: {{ selectedPrescriptionDate }}
            </td>
            <td class="expert-tool-history__comparison-row-chips">
              <v-chip v-for="indication in item.selected" :key="indication" class="expert-tool-history__comparison-chip">
                {{ indication }}
              </v-chip>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Component HistoryComparison.vue
 *
 * @module HistoryComparison
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [deprecated] app/src/APP_DASHBOARD/templates/views/ExpertTool/History/HistoryComparison.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'HistoryComparison',
  computed: {
    ...mapGetters({
      indicationCategories: 'expertTool/indicationCategories',
      selectedPrescription: 'expertTool/selectedPrescription',
      currentPrescription: 'expertTool/previousPrescription',
      previousPrescriptionDate: 'expertTool/previousPrescriptionDate',
      selectedPrescriptionDate: 'expertTool/selectedPrescriptionDate',
    }),
    comparisonItems() {
      const typeIndexes = {};
      const items = [];
      this.indicationCategories.forEach((type, index) => {
        typeIndexes[type.props.ruleType] = index;
        items.push({
          name: this.$ucfirst(this.$t(type.name, {catalog: type.catalog || "app_dashboard"})),
          color: type.color,
          current: [],
          selected: [],
        });
      });
      // Add current prescription indicators
      (this.currentPrescription.selectedRules || []).forEach(rule => {
        let typeIndex = typeIndexes[rule.type];
        if (typeIndex === undefined) {
          console.warn('Invalid indication found: ' + JSON.stringify(rule));
          return;
        }
        items[typeIndex].current.push(rule.name);
      });
      // Add selected prescription indicators
      const selectedRules = this.selectedPrescription ? this.selectedPrescription.selectedRules || [] : [];
      selectedRules.forEach(rule => {
        let typeIndex = typeIndexes[rule.type];
        if (typeIndex === undefined) {
          console.warn('Invalid indication found: ' + JSON.stringify(rule));
          return;
        }
        items[typeIndex].selected.push(rule.name);
      });
      return items;
    }
  },
};
</script>

<style lang="scss">
.expert-tool-history__comparison-chip {
  margin-right: 12px;
  margin-top: 6px;
  margin-bottom: 6px;
}
.expert-tool-history__comparison {
  padding-left: 40px;
}
.expert-tool-history__comparisonl-title {
  margin-bottom: 10px;
}
td.expert-tool-history__comparison-row-chips {
  padding: 6px 4px 6px 16px;
}
</style>
